import React from 'react';
import Footer from '../components/Footer';
import { Link } from 'react-router-dom';

export default function MyAccount() {
    window.scrollTo(0, 0)

    return (
        <>
            <div className="container-fluid account-content">
                <div className="row justify-content-center align-items-stretch">
                    <div className="col-5 image-side d-none d-md-block"></div>
                    <div className="col-11 col-sm-9 col-md-6 form-side d-flex flex-column justify-content-center align-items-center">
                        <h1 className='fw-semibold mb-5 login-heading'>LOGIN</h1>
                        <form action="" className='w-100'>
                            <div className="mb-3">
                                <input type="email" name='userName' className="form-control" placeholder='Username or Email Address *' required />
                            </div>
                            <div className="mb-3">
                                <input type="password" name='userPassword' className="form-control" placeholder='Password *' required />
                            </div>
                            <div className="mb-3 form-check remember-me-label">
                                <input type="checkbox" className="form-check-input" id='remember-me-check' />
                                <label className="form-check-label" htmlFor="remember-me-check">Remember Me</label>
                            </div>
                            <button type="submit" className="btn btn-primary login-btn fw-medium mt-3">Log In</button>
                        </form>
                        <div className='m-0 p-0 mx-auto mt-4 account-bottom-links'>
                            <a href="#" className='text-decoration-none lost-password'>Lost your password?</a>
                            <span className='mx-2'>|</span>
                            <Link to="/registration" className='text-decoration-none lost-password'>Sign Up</Link>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}
